/* eslint-disable complexity */

import { selectFiltersState } from 'tradera-apps/my-tradera/app/state/reducers/filters';

/** This matches query parameters to state filters.
 * @param {object} state
 * @returns {object}
 */
export const getAvailableQueryParams = state => {
    const filtersState = selectFiltersState(state);
    const checkModifiersExist =
        !!state && filtersState && filtersState.modifiers;
    return {
        'filters[buyerFilters][feedbackLeft]':
            checkModifiersExist && filtersState.modifiers.buyerFilters
                ? filtersState.modifiers.buyerFilters.feedbackLeft
                : '',
        'filters[buyerFilters][hidden]':
            checkModifiersExist && filtersState.modifiers.buyerFilters
                ? filtersState.modifiers.buyerFilters.hidden
                : '',
        'filters[buyerFilters][paid]':
            checkModifiersExist && filtersState.modifiers.buyerFilters
                ? filtersState.modifiers.buyerFilters.paid
                : '',
        'filters[datatype]': checkModifiersExist
            ? filtersState.modifiers.datatype
            : '',
        'filters[dateRange][field]':
            checkModifiersExist && filtersState.modifiers.dateRange
                ? filtersState.modifiers.dateRange.field
                : '',
        'filters[dateRange][from]':
            checkModifiersExist && filtersState.modifiers.dateRange
                ? filtersState.modifiers.dateRange.from
                : '',
        'filters[dateRange][to]':
            checkModifiersExist && filtersState.modifiers.dateRange
                ? filtersState.modifiers.dateRange.to
                : '',
        'filters[hasBids]': checkModifiersExist
            ? filtersState.modifiers.hasBids
            : '',
        'filters[itemCondition]': checkModifiersExist
            ? filtersState.modifiers.itemCondition
            : '',
        'filters[itemType]': checkModifiersExist
            ? filtersState.modifiers.itemType
            : '',
        'filters[paging][page]':
            checkModifiersExist && filtersState.modifiers.paging
                ? filtersState.modifiers.paging.page
                : '',
        'filters[paging][size]':
            checkModifiersExist && filtersState.modifiers.paging
                ? filtersState.modifiers.paging.size
                : '',
        'filters[processState]': checkModifiersExist
            ? filtersState.modifiers.processState
            : '',
        'filters[purchaseType]': checkModifiersExist
            ? filtersState.modifiers.purchaseType
            : '',
        'filters[query][properties]':
            checkModifiersExist && filtersState.modifiers.query
                ? filtersState.modifiers.query.properties
                : '',
        'filters[query][scope]':
            checkModifiersExist && filtersState.modifiers.query
                ? filtersState.modifiers.query.scope
                : '',
        'filters[query][searchQuery]':
            checkModifiersExist && filtersState.modifiers.query
                ? filtersState.modifiers.query.searchQuery
                : '',
        'filters[reservePriceReached]': checkModifiersExist
            ? filtersState.modifiers.reservePriceReached
            : '',
        'filters[searchType]': checkModifiersExist
            ? filtersState.modifiers.searchType
            : '',
        'filters[sellerFilters][feedbackLeft]':
            checkModifiersExist && filtersState.modifiers.sellerFilters
                ? filtersState.modifiers.sellerFilters.feedbackLeft
                : '',
        'filters[sellerFilters][hidden]':
            checkModifiersExist && filtersState.modifiers.sellerFilters
                ? filtersState.modifiers.sellerFilters.hidden
                : '',
        'filters[sellerFilters][paid]':
            checkModifiersExist && filtersState.modifiers.sellerFilters
                ? filtersState.modifiers.sellerFilters.paid
                : '',
        'filters[sellerFilters][shipped]':
            checkModifiersExist && filtersState.modifiers.sellerFilters
                ? filtersState.modifiers.sellerFilters.shipped
                : '',
        'filters[sellerFilters][shippingBooked]':
            checkModifiersExist && filtersState.modifiers.sellerFilters
                ? filtersState.modifiers.sellerFilters.shippingBooked
                : '',
        'filters[sort][order]':
            checkModifiersExist && filtersState.modifiers.sort
                ? filtersState.modifiers.sort.order
                : '',
        'filters[sort][sorting]':
            checkModifiersExist && filtersState.modifiers.sort
                ? filtersState.modifiers.sort.sorting
                : '',
        'filters[userIs]': checkModifiersExist
            ? filtersState.modifiers.userIs
            : '',
        'filters[selectedFilterBar]': checkModifiersExist
            ? filtersState.modifiers.selectedFilterBar
            : ''
    };
};

/**
 * Checks if a query parameter is in the available parameters.
 * @param {function} getState
 * @param {object} locationQuery
 */
export const checkStateOfQueryParams = (getState, locationQuery) => {
    let check = getAvailableQueryParams(getState());
    let checkItem = item =>
        !!check[item] &&
        check[item].toString() !== locationQuery[item].toString();
    return Object.keys(check).some(item => {
        if (!check[item] || !locationQuery[item]) {
            return false;
        }
        return checkItem(item) ? true : false;
    });
};
